<template>
    <div class="articale_comments mb-5 mt-5">
        <div id="comments">
            <h5>{{ comentariosList.length }} Comentarios</h5>
            <ul class="commentlist">
                <li 
                v-for="(comentario, index) in comentariosList" 
                :key="index"
                class="comment">
                    <div class="comment-body">
                        <div class="comment-author">
                           <i class="fa fa-commenting" aria-hidden="true"></i>
                            <span class="fn">{{comentario.nombre}} </span>
                        </div>
                        <div class="comment-meta commentmetadata">
                             {{format_create_date(comentario.created_at)}}
                        </div>
                        <div>
                             {{comentario.comentario}}
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    computed: {
        comentariosList() {
            return this.$store.state.fichaTecnica.comentarios;
        }
    },
    methods: {
        format_create_date: (date) => {
            return moment(date).format('ddd , DD MM YYYY LT');
        },
    }
};
</script>

<style lang="scss">
i.fa.fa-commenting {
    font-size: 30px;
}
</style>
